module.exports = __webpack_public_path__ + "static/media/TN-Men-Knit.cca33c6c.svg";